module.exports = __webpack_public_path__ + "static/media/Vale.827c18c6.svg";